'use client';
import { serverSignOut } from '@/app/user/user-actions';

import { ClickButton } from '../click-button';

export function SignOutButton() {
  return (
    <form
      className='flex items-center justify-center sm:justify-end'
      onSubmit={async (e) => {
        e.preventDefault();
        await serverSignOut();

        location.href = '/';
      }}
    >
      <ClickButton
        className='hidden'
        clickToDisable
        id='sign-out-button'
        key='sign-out-button'
        size='sm'
        variant='outline'
      >
        Sign Out
      </ClickButton>
    </form>
  );
}
